import React from "react";
import { AccrualCounterpartyDetailChanges } from "./AccrualCounterpartyDetailChanges";
import { AccrualDraftCopy } from "./accrualDraftCopy";
import { AccrualCounterpartyDetailChangesState } from "./useAccrualCounterpartyDetailChanges";

interface Props {
    detailChanges: AccrualCounterpartyDetailChangesState;
    copy: AccrualDraftCopy;
    isHighlighted: boolean;
    appearance?: "panel" | "cell";
    isDisabled?: boolean;
    onCreateNew: () => void;
}

export const AccrualDraftCounterpartyDetailChanges: React.FC<Props> = ({
    detailChanges,
    copy,
    isHighlighted,
    appearance = "panel",
    isDisabled = false,
    onCreateNew,
}) => (
    <AccrualCounterpartyDetailChanges
        key={detailChanges.counterparty?.id}
        changes={detailChanges.changes}
        counterparty={detailChanges.counterparty}
        mergeSeeds={detailChanges.mergeSeeds}
        replacePreview={detailChanges.replacePreview}
        isHighlighted={isHighlighted}
        loadError={
            detailChanges.isDetailsError ? copy.changedDetailsLoadError : null
        }
        onRetry={detailChanges.retryDetails}
        reviewLabel={copy.changedDetailsTask}
        newCounterpartyAction={copy.newCounterpartyAction}
        appearance={appearance}
        isDisabled={isDisabled}
        onMerged={detailChanges.finishMerge}
        onCreateNew={onCreateNew}
        onSkip={detailChanges.skip}
    />
);
